export{default as WebPBackgroundImage,WebPImage}from'./WebPBackgroundImage';export{default as ImageTile}from'./ImageTile';
//# sourceMappingURL=index.js.map